import { AuthService } from "../auth.service";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSmartModalService } from "ngx-smart-modal";
import { AppConstants } from "src/app/constants";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  credentialsCorrect: boolean;
  errorMessage: string;
  userLogged: boolean;
  verificacionToken: any;
  mensajeEmailVerificado = "";
  show: boolean = false;
  refresh_token: any;

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    private _route: Router,
    private route: ActivatedRoute,
    public auth: AuthService
  ) {
    this.credentialsCorrect = true;
  }

  ngOnInit(): void {
    let url_string = window.location.href;
    let url = new URL(url_string);
    let token = url.searchParams.get("token");

    if (token != undefined && token != null) {
      this.verificarCorreo(token);
    }
  }

  llamar1() {
    this.ngxSmartModalService.getModal("myModal").open();
  }
  llamar2() {
    this.ngxSmartModalService.getModal("myModal2").open();
  }
  llamar3() {
    this.ngxSmartModalService.getModal("myModal3").open();
  }
  onSubmit(form: any) {
    this.errorMessage = "";
    this.auth.loginUser(form.value).subscribe(
      (response: any) => {
        console.log(response);
        this.auth.setToken(response.access_token);
        this.refresh_token = response.refresh_token;

        this.auth.setAppURL(
          AppConstants.bienestarURL + "?tk=" + this.refresh_token
        );
        window.location.href =
          AppConstants.bienestarURL + "?tk=" + this.refresh_token;
      },
      (error) => {
        console.log(error);
        switch (error.error.code) {
          case "UNAUTHORIZED":
            this.errorMessage = "Correo y contraseña no coinciden";
            break;
          case "BAD_REQUEST":
            this.errorMessage = "Correo no verificado";
            break;
          default:
            break;
        }
      },

      () => {
        // this.auth.checkAvisoPrivacidad(this.auth.getToken()).subscribe(
        //   (response: any) => {
        //     console.log(response);
        //     if (response.message == "NOK") {
        //       // this.auth.autoStart = true;
        //       // this.auth.showAuth = false;
        //       window.location.href =
        //         AppConstants.bienestarURL + "?tk=" + this.refresh_token;
        //     }
        //     if (response.message == "OK") {
        //       window.location.href =
        //         AppConstants.bienestarURL + "?tk=" + this.refresh_token;
        //     }
        //   },
        //   (error) => {
        //     console.log(error);
        //   }
        // );
      }
    );
  }

  reset() {
    this.credentialsCorrect = true;
  }

  verificarCorreo(token) {
    window.history.replaceState(
      {},
      document.title,
      window.location.href.split("?")[0]
    );

    this.auth.verificarEmail(token).subscribe(
      (response: any) => {
        console.log(response);
        if (response.message == "OK") {
          this.mensajeEmailVerificado = "Correo verificado";
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  switchPass() {
    this.show = !this.show;
  }
}
